declare global {
  interface Array<T> {
    filterNotNull(): Array<T>;

    isEmpty(): boolean;

    isNotEmpty(): boolean;

    first(test?: (item: T) => boolean | undefined): T | undefined;

    last(test?: (item: T) => boolean | undefined): T | undefined;
  }

  interface String {
    isEmpty(): boolean;

    isNotEmpty(): boolean;
  }
}

export const first = <T>(data: T[] | undefined | null, test?: (item: T) => boolean | undefined | null) => {
  if (data) {
    if (test) {
      return data.filter((item) => test(item))[0];
    }
    return data[0];
  }
  return null;
};

export const last = <T>(data: T[] | undefined | null, test?: (item: T) => boolean | undefined | null) => {
  if (data) {
    if (test) {
      const filtered = data.filter((item) => test(item));
      return filtered[filtered.length - 1];
    }
    return data[data.length - 1];
  }
  return null;
};

// eslint-disable-next-line no-extend-native,func-names
Array.prototype.filterNotNull = function <T>() {
  const self = this as Array<T>;
  return self.filter((some): some is T => some !== undefined && some !== null);
};

// eslint-disable-next-line no-extend-native,func-names
Array.prototype.isEmpty = function <T>() {
  const self = this as Array<T>;
  return self.length <= 0;
};

// eslint-disable-next-line no-extend-native,func-names
Array.prototype.isNotEmpty = function <T>() {
  const self = this as Array<T>;
  return !self.isEmpty();
};

// eslint-disable-next-line no-extend-native,func-names
Array.prototype.first = function <T>(test?: (item: T) => boolean | undefined | null) {
  const self = this as Array<T>;
  return first(self, test);
};

// eslint-disable-next-line no-extend-native,func-names
Array.prototype.last = function <T>(test?: (item: T) => boolean | undefined | null) {
  const self = this as Array<T>;
  return last(self, test);
};

// eslint-disable-next-line no-extend-native
String.prototype.isEmpty = function () {
  const self = this as string;
  if (self) {
    return self.length < 1;
  }
  return true;
};

export const length = <T>(data: T[] | undefined | null) => {
  if (data) {
    return data.length;
  }
  return 0;
};

export const hasMultipleItems = <T>(data: T[] | undefined | null) => length(data) > 1;
